import React from 'react';
import './MessageReview.css';
import { ReactComponent as SelectedIcon } from '../../Assets/Images/option-selected.svg';
import { ReactComponent as NotSelectedIcon } from '../../Assets/Images/option-not-selected.svg';
import { ReactComponent as SendIcon } from '../../Assets/Images/paperplaneleft.svg';
import { ReactComponent as ArrowLeftIcon } from '../../Assets/Images/arrow-left.svg';
import { useDispatch, useSelector } from 'react-redux';
import { getPopupState } from '../../store/Feedback/FeedbackSelectors';
import { managePopUp } from '../../store/Feedback/FeedbackActions';

const OPTIONS = [
  {
    reason: 'Medically Inaccurate',
    description:
      'Information provided does not align with trusted medical guidelines or evidence',
  },
  {
    reason: 'Lacks Empathy',
    description:
      'Response feels cold or dismissive, not supportive of my experience',
  },
  {
    reason: 'Not Relevant',
    description: 'The response doesn’t address my question or topic',
  },
  {
    reason: 'Too Complex / Hard to Understand',
    description: 'Explanation is too technical or confusing',
  },
  {
    reason: 'Misinterpreted My Question',
    description:
      'The assistant misunderstood or misinterpreted what I was asking',
  },
  {
    reason: 'Outdated Information',
    description: 'The response contains outdated guidance or practices',
  },
  {
    reason: 'Doesn’t Respect Personal Choices',
    description:
      'The response doesn’t seem supportive of my personal health choices or decisions',
  },
  {
    reason: 'Requires a Citation',
    description:
      'The response needs supporting references or sources for credibility.',
  },
  {
    reason: 'Other',
    description: '',
  },
];

const ReviewPopUp = ({
  reviewSelected,
  setReviewSelected,
  sendFlag,
  modalHeight,
}) => {
  const dispatch = useDispatch();
  const { view, position } = useSelector(getPopupState);

  const selectOption = option => {
    if (option.reason === 'Other') {
      dispatch(managePopUp({ view: 'other' }));
    }
    setReviewSelected({ ...reviewSelected, ...option });
  };

  const sendReview = () => {
    sendFlag({
      value: 'bad',
      reason: reviewSelected.reason,
      description: reviewSelected.description,
    });
  };

  const otherSendEnabled =
    reviewSelected?.reason === 'Other' && reviewSelected?.description;
  const optionSendEnabled =
    (reviewSelected?.reason && reviewSelected.reason !== 'Other') ||
    otherSendEnabled;

  const otherReasonMaxLength = 500;

  const goBackToOptions = () => {
    dispatch(managePopUp({ view: 'options' }));
    if (!reviewSelected.description) {
      setReviewSelected({ ...reviewSelected, reason: '', description: '' });
    }
  };

  if (view === 'options') {
    return (
      <div
        style={{
          position: 'absolute',
          top: `${position.top}px`,
          left: `${position.left}px`,
          backgroundColor: 'white',
          padding: '15px',
          zIndex: 1000,
          borderRadius: '8px',
          width: '550px',
          height: modalHeight,
          maxHeight: modalHeight,
          // maxWidth: '550px',
          border: '0.5px solid rgba(0, 0, 0, 0.1)',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        {OPTIONS.map((option, index) => (
          <div
            key={index}
            onClick={() => selectOption(option)}
            role="button"
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginBottom: '5px',
              cursor: 'pointer',
            }}
          >
            <div style={{ marginTop: '3px' }}>
              {option.reason === reviewSelected?.reason ? (
                <SelectedIcon
                  style={{
                    width: '12px',
                    height: '12px',
                    marginRight: '5px',
                  }}
                />
              ) : (
                <NotSelectedIcon
                  style={{
                    width: '12px',
                    height: '12px',
                    marginRight: '5px',
                  }}
                />
              )}
            </div>
            <div>
              <div>{option.reason}</div>
              <div style={{ fontSize: '12px', opacity: '0.7' }}>
                {option.description}
              </div>
            </div>
          </div>
        ))}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            padding: '0 10px 0 10px',
          }}
        >
          <div
            onClick={sendReview}
            role="button"
            style={{
              cursor: 'pointer',
              opacity: optionSendEnabled ? 0.7 : 0.3,
            }}
            disabled={!optionSendEnabled}
          >
            <SendIcon
              style={{
                width: '20px',
                height: '20px',
              }}
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      style={{
        position: 'absolute',
        top: `${position.top}px`,
        left: `${position.left}px`,
        backgroundColor: 'white',
        padding: '15px',
        zIndex: 1000,
        borderRadius: '8px',
        width: '550px',
        // height: 'auto',
        height: modalHeight,
        maxHeight: modalHeight,
        // maxWidth: '550px',
        border: '0.5px solid rgba(0, 0, 0, 0.1)',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        onClick={() => {}}
        role="button"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: '10px',
          cursor: 'pointer',
        }}
      >
        <SelectedIcon
          style={{
            width: '12px',
            height: '12px',
            marginRight: '5px',
          }}
        />
        <div>Other:</div>
      </div>
      <div>
        <div
          style={{
            fontSize: '12px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <textarea
            className="Input"
            value={reviewSelected?.description}
            onChange={e =>
              setReviewSelected({
                ...reviewSelected,
                description: e.target.value,
              })
            }
            placeholder={'Write your reason...'}
            style={{
              width: '100%',
              height: '320px',
              padding: '10px',
              fontSize: '16px',
            }}
            maxLength={otherReasonMaxLength}
          />
          <div
            style={{
              textAlign: 'right',
              marginTop: '5px',
              fontSize: '12px',
              color: '#5f5a58',
            }}
          >
            {reviewSelected.description.length}/{otherReasonMaxLength}{' '}
            characters
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: '27px',
              padding: '0 10px 0 10px',
            }}
          >
            <div
              onClick={goBackToOptions}
              role="button"
              style={{
                cursor: 'pointer',
                opacity: 0.7,
              }}
            >
              <ArrowLeftIcon
                style={{
                  width: '20px',
                  height: '20px',
                }}
              />
            </div>
            <div
              onClick={sendReview}
              role="button"
              style={{
                cursor: 'pointer',
                opacity: otherSendEnabled ? 0.7 : 0.3,
              }}
              disabled={!otherSendEnabled}
            >
              <SendIcon
                style={{
                  width: '20px',
                  height: '20px',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewPopUp;
